import { FC } from 'react';
import { useFlowInfo } from '@flows/src/api/getFlowInfo';
import { useFlowsConfigureParams } from '@flows/src/hooks/flows-configure/useFlowsConfigureParams';
import FlowsConfigureAnvaCoverages from './FlowsConfigureAnvaCoverages';
import FlowsConfigureYellowhiveCoverages from './coverages/FlowsConfigureYellowhiveCoverages';

const FlowsConfigureCoveragesWrapper: FC = () => {
  const { flowId } = useFlowsConfigureParams();
  const { data: flowInfo } = useFlowInfo(flowId || '');

  const isYellowhiveFlow = flowInfo?.sub_type === 'YELLOWHIVE';

  if (isYellowhiveFlow) {
    return <FlowsConfigureYellowhiveCoverages />;
  }

  // Default to anva flows
  return <FlowsConfigureAnvaCoverages />;
};

export default FlowsConfigureCoveragesWrapper;
